<!-- @catalog Star rating input/display (1-5), wraps q-rating -->
<template>
  <div
    class="c-star-rating"
    :class="{ 'c-star-rating--boxed': readonly === false }"
  >
    <q-rating
      v-model="numericModel"
      :max="5"
      size="20px"
      icon="fa-solid fa-star"
      color="grey-200"
      color-selected="yellow-500"
      no-dimming
      :readonly
      :icon-aria-label="STAR_LABELS"
    >
      <template v-for="n in 5" :key="n" v-slot:[`tip-${n}`]>
        <c-tooltip>{{ STAR_LABELS[n - 1] }}</c-tooltip>
      </template>
    </q-rating>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";

const STAR_LABELS = [
  "1 ster",
  "2 sterren",
  "3 sterren",
  "4 sterren",
  "5 sterren",
];

const model = defineModel<string | null>({ default: null });

defineProps({
  readonly: {
    type: Boolean,
    default: false,
  },
});

const numericModel = computed<number>({
  get: () => (model.value === null ? 0 : Number(model.value)),
  set: (value: number) => {
    model.value = value === 0 ? null : String(value);
  },
});
</script>

<style lang="scss" scoped>
.c-star-rating {
  @apply tw-inline-flex tw-items-center;

  // Input variant: same 40px bordered box as c-input.
  &--boxed {
    @apply tw-h-10 tw-rounded-lg tw-border tw-border-grey-200 tw-px-3;
  }

  // Quasar ships a drop shadow on rating icons and a 2px gap; the design has
  // flat stars 8px apart.
  :deep(.q-rating__icon) {
    text-shadow: none;
  }

  :deep(.q-rating__icon-container + .q-rating__icon-container) {
    @apply tw-ml-2;
  }
}
</style>
